import { Outlet } from 'react-router-dom'
import { useApp } from '@/presentation/hooks/useApp'
import TabBar from './TabBar'

/**
 * 主页面布局组件 (带有底部导航栏)
 * 职责：渲染包含 TabBar 的公共页面结构
 */
export function MainLayout() {
  const { activeTab, handleTabChange } = useApp()

  return (
    <>
      {/* 渲染子页面内容 */}
      <Outlet />

      {/* TabBar 安全距离 */}
      <div className='h-20' />

      {/* 底部导航栏 */}
      <div className='fixed bottom-0 left-1/2 z-20 w-full max-w-(--max-width) -translate-x-1/2'>
        <TabBar activeTab={activeTab} onTabChange={handleTabChange} />
      </div>
    </>
  )
}
